import { handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import { biFormsByDateSuccess, biFormsBySiteAndDateSuccess, setLoadingState } from './actions';

export default handleActions(
  {
    [biFormsBySiteAndDateSuccess](state, { payload }) {
      return {
        ...state,
        bySiteAndDate: payload,
      };
    },
    [biFormsByDateSuccess](state, { payload }) {
      return {
        ...state,
        byDate: payload,
      };
    },
    [setLoadingState](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
